import * as React from "react";

class SchedulePopover extends React.Component<any, any> {
  render() {
    let timeZoneSection;
    let helperTextSection;
    let className = `${this.props.popover_type}+-popver`;

    switch (this.props.time_zone) {
      case "America/New_York":
        timeZoneSection = (
          <em>
            Report delivery will occur as soon as the data is available;
            typically between 07:00 AM and 10:00 AM EST.
          </em>
        );
        break;
      case "America/Los_Angeles":
        timeZoneSection = (
          <em>
            Report delivery will occur as soon as the data is available;
            typically between 04:00 AM and 07:00 AM PST.
          </em>
        );
        break;
    }

    switch (this.props.popover_type) {
      case "daily":
        helperTextSection = (
          <p>
            {" "}
            Reports will be delivered daily. Note that data is updated daily for
            the previous day.
            <br />
            <br />
          </p>
        );
        break;
      case "weekly":
        helperTextSection = (
          <p>
            Reports will be delivered weekly on the specified weekday. Note that
            data is updated daily and is
            <br />
            available for the previous day.
            <br />
            <br />
          </p>
        );
        break;
      case "monthly":
        helperTextSection = (
          <p>
            Repeats monthly on day {this.props.day}. Note that data is updated
            daily and is available for the previous day. <br />
            <br />
          </p>
        );
        break;
    }

    return (
      <div className={className}>
        <p>
          {helperTextSection}
          {timeZoneSection}
        </p>
      </div>
    );
  }
}

export default SchedulePopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportSchedule/SchedulePopover.tsx